import Cookies from 'js-cookie';
import { COOKIE_KEY, LSTORAGE_KEY } from 'src/constants';
import { IS_PRODUCTION } from 'src/constants/env';
import LocalStore from './storage';

interface ICookie {
    setWithDomain(key: string, data: any, domain: string): ICookie;
    set(key: string, data: any, options?: any): ICookie;
    get(key: string): any;
    remove(key: string): ICookie;
}

export const CookieStore: ICookie = {
    setWithDomain(key: string, data: any, domain: string): ICookie {
        Cookies.set(key, data, {
            path: '/',
            expires: 30,
            domain: domain,
        });
        return this;
    },
    set(key: string, data: any, options: any = {}): ICookie {
        const _domain = IS_PRODUCTION ? 'baomoi.com' : '';
        Cookies.set(key, data, {
            path: '/',
            expires: 30,
            domain: _domain,
            ...options,
        });
        return this;
    },
    get(key: string): any {
        return Cookies.get(key);
    },
    remove(key: string): ICookie {
        Cookies.remove(key);
        return this;
    },
};

export const getGy = (): string => {
    try {
        const _BM = (window as any)._BM || {};
        let gy = _BM.bmGy;
        if (!gy) {
            gy = CookieStore.get(COOKIE_KEY.BM_GY);
            _BM.bmGy = gy;
        };
        return gy;
    } catch (error) {
        return '';
    }
};

export const getVisitorID = (): string => {
    try {
        let visitorId = (window as any).ZA?.getVisitorID();
        if (!visitorId) visitorId = CookieStore.get('adtimaUserId');
        if (!visitorId) visitorId = LocalStore.get(COOKIE_KEY.ZA_ID);
        return visitorId;
    } catch (error) {
        return CookieStore.get('adtimaUserId') || '';
    }
};

export const getUserId = () => {
    let userId = undefined;
    if (CookieStore.get('EpiUser'))
        userId = JSON.parse(unescape(CookieStore.get('EpiUser'))).userId;
    if (!userId) userId = CookieStore.get('oa2UserId');
    if (!userId) userId = CookieStore.get('bmuid');

    return userId;
};

export const getUserZaloId = () => {
    let userId = undefined;
    if (typeof window !== 'undefined') {
        if (!userId) userId = CookieStore.get('za_bm_uid');
    }
    return userId;
};

export default CookieStore;
